import React from "react";
import { View, TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";
import AppTheme from "../../AppTheme";

export default function Bell(props) {
  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M14.5699 12.3213C13.7797 11.0154 13.3528 9.52217 13.3332 7.99597V5.3373C13.3332 3.92281 12.7713 2.56626 11.7711 1.56606C10.771 0.56587 9.4144 0.00396729 7.99991 0.00396729C6.58542 0.00396729 5.22887 0.56587 4.22867 1.56606C3.22848 2.56626 2.66658 3.92281 2.66658 5.3373V7.99197C2.64772 9.51953 2.22075 11.0143 1.42991 12.3213C1.36869 12.4224 1.33544 12.5379 1.33358 12.6561C1.33171 12.7743 1.3613 12.8908 1.4193 12.9938C1.4773 13.0968 1.56163 13.1825 1.66365 13.2421C1.76568 13.3018 1.88172 13.3333 1.99991 13.3333H13.9999C14.1181 13.3333 14.2341 13.3018 14.3362 13.2421C14.4382 13.1825 14.5225 13.0968 14.5805 12.9938C14.6385 12.8908 14.6681 12.7743 14.6662 12.6561C14.6644 12.5379 14.6311 12.4224 14.5699 12.3213Z"
          fill={AppTheme.almostBlack}
        />
        <Path
          d="M8.6713 15.8833C8.95071 15.7837 9.20447 15.6233 9.41421 15.4135C9.62395 15.2038 9.78441 14.95 9.88397 14.6706H6.11597C6.20412 14.918 6.34015 15.1457 6.51628 15.3405C6.69241 15.5354 6.90519 15.6936 7.14248 15.8062C7.37976 15.9188 7.6369 15.9836 7.89922 15.9968C8.16154 16.01 8.42389 15.9715 8.6713 15.8833Z"
          fill={AppTheme.almostBlack}
        />
      </Svg>
    </TouchableOpacity>
  );
}
